export const NAME = 'invitations';
